import { bindAll } from 'shared/decorators/bindAll';
import { createLogger } from 'shared/services/logger';
import { pull } from 'shared/util';

const logger = createLogger('Shared:Stores:Dispatcher', ['error']);

@bindAll
export class Dispatcher {
  // ref to the store that owns this dispatcher.
  store = null;
  // container for registered event handlers
  actions = {};

  constructor (store) {
    this.store = store;
  }

  register (action, delegate) {
    if (!this.actions[action]) {
      this.actions[action] = [];
    }
    this.actions[action].push(delegate);
  }

  unregister (action, delegate) {
    if (!this.actions[action]) {
      return;
    }
    pull(this.actions[action], delegate);
  }

  async dispatch (action, ...args) {
    const delegates = this.actions[action];

    if (!delegates) {
      logger.warn(`Action "${action}" not found`);
      return;
    }

    logger.log(action, ...args);

    try {
      await Promise.all(delegates.map((delegate) => {
        return delegate(this.store, ...args);
      }));
    } catch (ex) {
      logger.error(`Unhandled exception executing ${action}:`, ex);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/core/Dispatcher.js